import { useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchSchoolsRequest, resetSchoolsFailure } from '../../actions/fetchSchoolsActions';
import {
  schoolsSelector,
  fetchSchoolsLoadingSelector,
  fetchSchoolsErrorSelector,
  selectedSchoolSelector,
} from '../../reducers/selectors';

const useSchools = () => {
  const [reload, setReload] = useState(0);
  const dispatch = useDispatch();
  const data = useSelector(schoolsSelector);
  const isLoading = useSelector(fetchSchoolsLoadingSelector);
  const error = useSelector(fetchSchoolsErrorSelector);
  const selected = useSelector(selectedSchoolSelector);

  useLayoutEffect(() => {
    if (!error && !isLoading && data.length === 0) {
      dispatch(fetchSchoolsRequest());
    }
  }, [dispatch, data, error, isLoading]);

  const reset = () => {
    dispatch(resetSchoolsFailure());
    setReload(reload + 1);
  };

  return {
    data,
    isLoading,
    error,
    reload: () => reset(),
    retries: reload,
    selected,
  };
};

export default useSchools;
